import React from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  IconButton,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from '@mui/system';
import Styles from '../Styles/SearchCustodiansStyles';
import { menuItem } from './../../../assets/styles/appStyles';

export default function CustodianSearchStates({
  onSearchChanged,
  searchText,
  setState,
  state,
  useNative = false,
}: Readonly<{
  onSearchChanged: (searchText?: string, stateId?: string) => void;
  searchText: string;
  state: string | undefined;
  setState: (s: string | undefined) => void;
  useNative: boolean;
}>) {
  const handleChangeState = (value: string) => {
    setState(value);
    onSearchChanged(searchText, value);
  };

  const handleClearSelection = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    setState(undefined);
    onSearchChanged(searchText, undefined);
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <FormControl fullWidth>
        <InputLabel id="search-state-label">Type</InputLabel>
        <Select
          native={useNative}
          labelId="search-state-label"
          id="search-state"
          value={state ?? ''}
          label="Type"
          onChange={(e: SelectChangeEvent) => handleChangeState(e.target.value)}
          sx={{
            pr: state ? 5 : 2,
          }}
        >
          <MenuItem key="facility" value="facility" sx={menuItem}>
            <Grid container sx={Styles.alignCenter}>
              <Grid item xs={10} sx={Styles.alignCenter}>
                Facility
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem key="custodian" value="custodian" sx={menuItem}>
            <Grid container sx={Styles.alignCenter}>
              <Grid item xs={10} sx={Styles.alignCenter}>
                Custodian
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem key="both" value="both" sx={menuItem}>
            <Grid container sx={Styles.alignCenter}>
              <Grid item xs={10} sx={Styles.alignCenter}>
                Both
              </Grid>
            </Grid>
          </MenuItem>
        </Select>

        {state && (
          <IconButton
            size="small"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={handleClearSelection}
            sx={{
              position: 'absolute',
              right: 32,
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 2,
              color: 'action.active',
              '&:hover': { color: 'error.main', backgroundColor: 'transparent' },
            }}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        )}
      </FormControl>
    </Box>
  );
}
